import { React, useState, useEffect, useRef } from "react";
import MiscUploadPDFView from "../misc_components/MiscUploadPDFView";
import Footer from "../Footer";
import NavBar from "../NavBar";
import MiscPageTitle from "../misc_components/MiscPageTitle";
import MiscPageMidSection from "../misc_components/MiscPageMidSection";
import HomeScreenHowToUse from "../home_screen/HomeScreenHowToUse";
import MiscWhyUse from "../misc_components/MiscWhyUse";
import MiscPageLookingFor from "../misc_components/MiscPageLookingFor";
import LoadingBar from "react-top-loading-bar";
import { useLocation, ScrollRestoration } from "react-router-dom";
import { PageContext } from "../../App";
import ImageConverterImageListScreen from "./ImageConverterImageListScreen";
import MiscDownloadOnAppStore from "../misc_components/MiscDownloadOnAppStore";
import { BASE_URL } from "../Config";
import MiscFAQ from "../misc_components/MiscFAQ";
import MiscRecommendedPages from "../misc_components/MiscRecommendedPages";

function ImageConverterMain() {
  //location
  const location = useLocation();
  // Use optional chaining or a guard in case state is undefined
  const { title } = location.state || {
    title: "Image Converter, Image Compressor Free",
  };

  //selected files
  const [selectedFiles, setSelectedFiles] = useState([]);
  //show edit screen
  const [showEditFileScreen, setShowEditFileScreen] = useState(false);
  //start processing
  const [startProcessingFiles, setStartProcessingFiles] = useState(false);

  //reference loading bar
  const loadingBarRef = useRef(null);

  //looking for object
  //requires 3 data objects
  //to show keywarded navigation
  const lookingForObject = {
    data1: { link: "/image_converter", title: "Image Compressor Online" },
    data2: { link: "/image_converter", title: "Image Converter Online" },
    data3: { link: "/image_converter", title: "Compress Images Free" },
  };

  //use effect to handle the submit button click
  useEffect(() => {
    //check
    if (startProcessingFiles === true) {
      //show file edit screen
      setShowEditFileScreen(true);

      console.log(
        "Start file processing. Number of files: ",
        selectedFiles.length
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [startProcessingFiles]);

  return (
    <PageContext.Provider
      value={{
        selectedFiles,
        setSelectedFiles,
        startProcessingFiles,
        setStartProcessingFiles,
        setShowEditFileScreen,
      }}
    >
      {/* Scroll to top */}
      <ScrollRestoration />
      {/* Loading Bar */}
      <LoadingBar ref={loadingBarRef} />

      {/*Add title and metadata */}
      <title>{title + " Offline"}</title>
      <meta name="robots" content="index, follow"></meta>
      <link
        rel="canonical"
        href={`${BASE_URL}${lookingForObject.data1.link}`}
      />
      <meta
        name="description"
        content="Convert images online easily. Change formats like JPG, PNG, GIF, or BMP quickly with our fast, secure, and user-friendly image converter tool."
      ></meta>
      <meta
        name="keywords"
        content="image converter, convert images online, JPG to PNG, PNG to JPG, image format converter, online image converter, GIF to JPG, BMP to JPG, image file converter, photo converter online, convert image formats, image conversion tool, online photo converter, picture format converter, image editor online"
      ></meta>

      {/* page content */}
      {showEditFileScreen ? (
        <ImageConverterImageListScreen
          title={title}
        ></ImageConverterImageListScreen>
      ) : (
        <div>
          {/* Nav Bar */}
          <NavBar />
          {/* Title */}
          <MiscPageTitle title={title} online={false} />
          {/* Upload PDF View */}
          <MiscUploadPDFView
            selectMultiple={true}
            filetype={{
              "image/*": [], // This MIME type accepts all image formats
            }}
          />
          {/* Mid Section */}
          <MiscPageMidSection description="Our Image Converter website provides a powerful, fast, and secure solution to convert, resize, compress, and edit images without requiring an internet connection. Built to work fully offline, this all-in-one tool allows users to process images directly on their device, ensuring complete privacy and data protection. Whether you need to change image formats, reduce file size, or adjust dimensions, this platform delivers professional results with ease. Users can also choose to work online, making it flexible enough to function as an image converter online, online image converter, and image editor online when needed. The tool supports popular formats and advanced features, allowing users to resize images, scale images, and optimize visuals for websites, social media, and documents. Acting as both an image compressor online and an offline editor, it reduces image size while preserving quality and clarity. Ideal for designers, students, marketers, and everyday users, this website simplifies image workflows with a clean interface and high-performance processing. If you are searching for a secure image converter, a reliable image converter online, jpg to png converter, png to jpg converter, jpg to webp converter, image to grayscale converter, image compressor or an efficient way to resize images, scale images, and edit visuals using an online image converter with offline support, this platform delivers a seamless experience built for modern image management." />
          {/* How to use */}
          <HomeScreenHowToUse
            steps={{
              step1: "Select",
              step2: "Offline",
              step3: "Convert",
              step4: "Download",
            }}
          />
          {/* Why use section */}
          <MiscWhyUse
            title="Image Converter"
            why_use={[
              {
                title: "Convert Images Between Multiple Formats",
                description:
                  "Our image converter allows users to change image formats like JPG, PNG, WEBP, and more for better compatibility and usage.",
              },
              {
                title: "Optimize Images for Web and Mobile",
                description:
                  "Using an image compressor online reduces image file size, helping websites and mobile apps load faster.",
              },
              {
                title: "Resize Images for Different Platforms",
                description:
                  "This image resizer helps resize images accurately for social media, websites, emails, and documents.",
              },
              {
                title: "Scale Images Without Quality Loss",
                description:
                  "Modern tools can scale images up or down while maintaining clarity, sharpness, and visual quality.",
              },
              {
                title: "Improve Website Performance and SEO",
                description:
                  "Compressed and resized images improve page speed. Using an online image converter helps boost SEO rankings.",
              },
              {
                title: "Save Storage Space",
                description:
                  "Our image compressor reduces image file size, freeing up device and cloud storage space.",
              },
              {
                title: "Faster Sharing and Uploading",
                description:
                  "Smaller optimized images upload faster. This image converter online makes sharing quick and easy.",
              },
              {
                title: "Offline Processing for Privacy and Security",
                description:
                  "Our offline image converter and image resizer process images locally, keeping personal and professional files secure.",
              },
              {
                title: "Useful for Designers, Marketers, and Students",
                description:
                  "Professionals rely on image editor online and offline tools to prepare images for projects and presentations.",
              },
            ]}
          />
          {/* FAQ */}
          <MiscFAQ
            faq_list={[
              {
                title: "How can I convert images online for free?",
                description:
                  "Visit ShivaPDF.com and open the Image Converter tool. Select an image, choose your desired output format from the available options, and start the conversion. Download the converted image to your device when it is ready.",
              },
              {
                title: "Can I convert images offline?",
                description:
                  "You can convert images offline if the converter and all required processing resources are available locally on your device. You may need an internet connection to load the tool initially if its scripts or other resources are not stored locally.",
              },
              {
                title: "Can I convert images without uploading them?",
                description:
                  "If ShivaPDF processes images entirely in your browser, you can convert them without uploading the files to a remote server. Local processing can help protect the privacy of personal photos and confidential images.",
              },
              {
                title: "Is it safe to convert images locally in a browser?",
                description:
                  "Local image conversion can help protect your privacy because your files do not need to be sent to a remote server. If you are converting sensitive images, verify that the tool performs the conversion locally and does not transmit your files.",
              },
              {
                title: "What is an image converter?",
                description:
                  "An image converter changes an image from one file format to another. It helps you convert pictures and graphics into formats suitable for websites, sharing, printing, editing, and storage.",
              },
              {
                title: "Which image formats can I convert?",
                description:
                  "Supported formats depend on the converter's implementation. Common image formats include JPG, JPEG, PNG, WebP, GIF, BMP, and TIFF. Check the ShivaPDF Image Converter page to confirm the available input and output formats.",
              },
              {
                title: "Can I convert JPG to PNG?",
                description:
                  "Yes, JPG images can be converted to PNG when both formats are supported. PNG is useful for graphics, screenshots, and images that require lossless compression, although converting a JPG to PNG cannot restore image details already lost through JPEG compression.",
              },
              {
                title: "Can I convert PNG to JPG?",
                description:
                  "Yes, you can convert PNG images to JPG if the tool supports both formats. JPEG is often suitable for photographs and smaller web images, but it does not support transparency, so transparent areas may be filled with a background color.",
              },
              {
                title: "Can I convert WebP images to JPG or PNG?",
                description:
                  "You can convert WebP images to JPG or PNG when the converter supports these formats. JPG is commonly used for photographs, while PNG is useful for graphics and images that need transparency.",
              },
              {
                title: "Can I convert images to WebP?",
                description:
                  "If WebP is available as an output format, you can convert supported images to WebP for use on websites and other digital platforms. WebP can provide efficient compression, with results depending on the image content and conversion settings.",
              },
              {
                title: "Does converting an image reduce its quality?",
                description:
                  "Image quality depends on the source format, destination format, and compression settings. Converting to a lossy format such as JPG may reduce image quality, while lossless formats can preserve pixel data during conversion when supported correctly.",
              },
              {
                title: "Can I convert images without changing their dimensions?",
                description:
                  "Image format conversion generally preserves the original image dimensions unless resizing is included in the conversion process. Check the output settings and compare the downloaded image dimensions if preserving the exact size is important.",
              },
              {
                title: "Can I convert transparent PNG images?",
                description:
                  "Yes, if PNG is supported by the converter. Transparency can generally be retained when converting to another format that supports it, such as WebP, but formats such as JPG do not support transparent backgrounds.",
              },
              {
                title: "Can I convert multiple images at once?",
                description:
                  "Batch image conversion is possible if the tool supports selecting and processing multiple files in one operation. Check the ShivaPDF Image Converter page for available batch processing options and any file limits.",
              },
              {
                title: "Can I convert images on my mobile phone?",
                description:
                  "You can access ShivaPDF.com through a supported browser on an iPhone, Android phone, or tablet. Select an image from your device and choose an available output format to convert it.",
              },
              {
                title: "Do I need to install software to convert images?",
                description:
                  "No separate desktop application is required when using a browser-based image converter. Open ShivaPDF.com in a supported browser and follow the available steps to convert and download your image.",
              },
              {
                title: "Can I convert large image files?",
                description:
                  "Large images may require additional memory and processing time. The maximum file size depends on the converter's limits, the image format, and your device's available resources.",
              },
              {
                title: "Can I convert images without creating an account?",
                description:
                  "You can use the Image Converter without registering if ShivaPDF does not require an account for this feature. Check the converter page for any current access requirements or usage limits.",
              },
              {
                title: "Why is my converted image larger than the original?",
                description:
                  "The output file size depends on the destination format, compression method, image content, and quality settings. For example, converting a compressed JPG to a lossless PNG can produce a larger file without improving the original image quality.",
              },
              {
                title: "Why can't I open my converted image?",
                description:
                  "The file may not have converted correctly, the output format may not be supported by your viewer, or the download may be incomplete. Try downloading the image again and confirm that the file extension matches the selected output format.",
              },
              {
                title: "How do I download a converted image?",
                description:
                  "After conversion finishes, select the download option to save the converted image to your device. Open the downloaded file to verify its format, appearance, dimensions, and quality.",
              },
              {
                title: "Why should I use ShivaPDF to convert images?",
                description:
                  "ShivaPDF provides browser-based tools for common image and PDF tasks without requiring separate desktop software. Use the Image Converter to change supported image formats for websites, documents, sharing, and everyday projects.",
              },
            ]} />
          {/* Download on Appsroe */}
          <MiscDownloadOnAppStore
            id={`https://apps.apple.com/app/id${1614646280}`}
          />
          {/* Looking for section */}
          <MiscPageLookingFor data={lookingForObject} />
          {/* Recommended Tools */}
          <MiscRecommendedPages />
          {/* Footer */}
          <Footer />
        </div>
      )}
    </PageContext.Provider>
  );
}

export default ImageConverterMain;
